module.exports = __webpack_public_path__ + "media/images/players/SURRATT_CALEB-b6a746777166a9535ad3d333b3ce2397.png";